import React from "react";
import styles from "../styling/initialLoadingScreen.module.css";
import NavBar from "./NavBar";

function InitialLoadingScreen() {
  return (
    <>
      <NavBar />
      <div className={styles.container}>
        <div className={styles.content}>
          <div>
            <div
              className={`${styles["loading-block"]} ${styles["block-1"]}`}
            />
            <div
              className={`${styles["loading-block"]} ${styles["block-2"]}`}
            />
            <div
              className={`${styles["loading-block"]} ${styles["block-3"]}`}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default InitialLoadingScreen;
